var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomepageBg = function SvgHomepageBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1146 750"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#homepage_bg_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#homepage_bg_svg__b)",
    d: "M223.862 1031.79C21.035 629.111 333.108 207.968 730.05-5.87c380.49-204.972 898.17-271.892 1101.24 109.612 177.03 332.597-25.98 662.522-305.51 915.158-377.22 340.92-1073.188 466.99-1301.918 12.89Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "homepage_bg_svg__b",
    x1: 1359.71,
    x2: 704.249,
    y1: 1143.62,
    y2: 8.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#885AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00193F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "homepage_bg_svg__a",
    width: 2057.47,
    height: 1817.01,
    x: 0.164,
    y: -331.286,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_704_1852",
    stdDeviation: 80
  })))));
};
export default SvgHomepageBg;